$(function () {
  const announcementBar = $('.announcement-bar.mobile');

  const $mq = $(announcementBar).marquee({
    duration: '15000',
    gap: 0,
    delayBeforeStart: 0,
    direction: 'left',
    startVisible: true,
    duplicated: false,
    pauseOnHover: false
  });
});
